import { Link } from "@mui/icons-material";
import { Box, Button, OutlinedInput, Popover, Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import React from "react";
import { useTranslation } from "react-i18next";
import { generateOrganizationUserSecret } from "services/api";
import { showSnackbar } from "services/snackbarHelper";

const GenerateKeyButton = ({ organizationId, userId }: { organizationId: string; userId: string }) => {
	const { t } = useTranslation();
	const [expxireDays, setExpireDays] = React.useState(7);

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		event.preventDefault();
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleCreate = (params) => {
		generateOrganizationUserSecret(organizationId, userId, expxireDays).then((resp) => {
			navigator.clipboard.writeText(window.location.origin + "/app/signin?secretKey=" + resp.secretKey);
			showSnackbar(t("generateSecretKeySuccess", { ns: "validation" }), "success");
		});
	};

	return (
		<>
			<GridActionsCellItem
				icon={<Link />}
				onClick={handleOpen}
				label={t("generateLoginLink")}
			/>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}>
				<Box
					display="flex"
					flexDirection="row"
					gap={1}
					sx={{ px: 2, py: 1 }}>
					<Typography>
						{t("generateSecretKey1")}
						<OutlinedInput
							value={expxireDays}
							onChange={(e) => setExpireDays(parseInt(e.target.value))}
							type="number"
							size="small"
							sx={{ width: 80 }}
						/>
						{t("generateSecretKey2")}
					</Typography>
					<Button
						size="small"
						variant="contained"
						onClick={handleCreate}>
						{t("generate")}
					</Button>
				</Box>
			</Popover>
		</>
	);
};

export default GenerateKeyButton;
